import React, { useContext, useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import UserContext, { Roles } from '../../contexts/UserContext'
import GlobalLoadingOverlay from '../GlobalLoadingOverlay'

interface AdminGuardProps {
  children: React.ReactNode
  redirectTo?: string
}

const AdminGuard: React.FC<AdminGuardProps> = ({
  children,
  redirectTo = '/panel'
}) => {
  const { user, token, isLoadingAuth } = useContext(UserContext)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    if (!isLoadingAuth && token) {
      const timer = setTimeout(() => {
        setIsChecking(false)
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isLoadingAuth, token])

  if (isLoadingAuth || isChecking) {
    return <GlobalLoadingOverlay />
  }

  if (token && (!user || (!user.id && !user.sub))) {
    return <GlobalLoadingOverlay />
  }

  if (user.role !== Roles.globalAdmin) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}

export default AdminGuard
